import { useAuth } from "../contexts/auth-context";
import { isMyLove } from "../utils/auth";
import { PACOCA_URL } from "../utils/vars";

export function GlobalAccount(){
    const { user } = useAuth();
    
    return (
        <>
            <h1 className="text-center" style={{marginBottom: "20px", fontSize: "40px"}}>Conta</h1>
            {!isMyLove(user) ? 
                <p>Atualize as informações da sua conta pelo <a href={`${PACOCA_URL}/conta`} target="_blank" rel="noopener noreferrer">Central de Contas</a> Alterações são refletidas no Paçoca, Read Books, Cronos e Rita!</p>
                : 
                <p className="text-center">Você não pode mudar seu nome</p>
            }

            <div className="form-group row mb-3">
                <div className="col">
                    <label htmlFor="name" className="col-md-4 col-form-label text-md-right">Nome</label>
                    <input disabled placeholder="Email ou nome de usuário" id="email" type="login" className="form-control" name="login" value={user?.user_name}/>
                </div>
            </div>
        </>
    );
}